/* eslint-disable */
import {defineStore} from 'pinia';
// import {Dialog} from 'quasar'
import axios from "axios"

const API_URL = process.env.VUE_APP_API;

// Helpers
function mapCategories(row) {
	let cat = {
		id: row.id,
		name: row.name,
		description: "",
		parent: 0
	}
	return cat
}

// Currency z DB, UID z DB !!!

export const useLegacyKioskStore = defineStore('legacyKiosk', {
	state: () => ({
		drawerOpen: true,
		leftDrawerOpen: true,
		rightDrawerOpen: false,
		headerOpen: true,
		menuList: [],
		itemList: [],
		selectedItem: {},
		products: [],
		categories: [],
		processState: "intro",
		openMenu: 0, // => tahat z DB!!!
		appTimerTime: 60000, // => tahat z DB!!!
		defaultLang: "sk", // => tahat z DB!!!
		uid: '', // => tahat z DB!!!
		kid: 0, // => tahat z DB!!!
		aid: 0, // => tahat z DB!!!
		bid: 0, // => tahat z DB!!!
		localeOptions: [
			{lang: "Česky", code: "cz", flag: "", iso: 0},
			{lang: "English", code: "en", flag: "", iso: 0},
			{lang: "Slovensky", code: "sk", flag: "", iso: 0}], // Toto tahaz z DB Settings
		languages: [],
		setUidDialog: false,
		kiosk: [],
		currency: '',
		currencyObject: {},
		syncedKiosk: {},
		syncState: false,
		paymentOptions: [],
		kioskStatus: null,
		DESIGN: {}, // z DB
		SEPTIM: {
			OUTLET_ID: 0,
			URL: '',
			WEBCARE: '',
			LANG: 'cz',
			TOKEN: '',
			AUTH: '',
			ACCOUNT: {
				name: '',
				street: '',
				houseNum: '1',
				city: '',
				zip: '',
				country: '',
				contact: ''
			}
		},
		activeTimer: null,
		template: 'custom' // z DB: custom - is
	}),
	actions: {
		async getKiosk(uid) {
			if(!uid) {
				return;
			}
			await axios.get(`${API_URL}/api/${uid}/kiosk`)
				.then((response) => {
					console.log(response);
					// handle success
					// const data = response
					console.log("Kiosk", response.data);
					this.kiosk = response.data
					// Parse result
					this.uid = this.kiosk.uid
					this.kid = this.kiosk.kid
					this.aid = this.kiosk.aid
					this.bid = this.kiosk.bid
					this.openMenu = this.kiosk.openMenu
					this.appTimerTime = this.kiosk.appTimerTime
					this.defaultLang = this.kiosk.defaultLang
					this.paymentOptions = this.kiosk?.paymentOptions?.split(",") || []
					// this.DESIGN = {}
					// this.DESIGN = JSON.parse(window.atob(this.kiosk.DESIGN))
					// this.DESIGN = window.atob(this.kiosk.DESIGN)
					this.DESIGN = this.kiosk.DESIGN
					if(this.DESIGN) {
						document.body.classList.remove(this.template)
						this.template = this.DESIGN.template
						document.body.classList.add(this.template)
					}
					// TODO: Prekopat na novu verziu API
					this.SEPTIM.OUTLET_ID = this.kiosk.SEPTIM_OUTLET_ID
					this.SEPTIM.URL = this.kiosk.SEPTIM_URL
					this.SEPTIM.WEBCARE = this.kiosk.SEPTIM_WEBCARE
					this.SEPTIM.LANG = this.kiosk.SEPTIM_LANG
					this.SEPTIM.ACCOUNT.name = this.kiosk.ACCOUNT_NAME
					this.SEPTIM.ACCOUNT.street = this.kiosk.ACCOUNT_STREET
					this.SEPTIM.ACCOUNT.city = this.kiosk.ACCOUNT_CITY
					this.SEPTIM.ACCOUNT.zip = this.kiosk.ACCOUNT_ZIP
					this.SEPTIM.ACCOUNT.country = this.kiosk.ACCOUNT_COUNTRY
					this.SEPTIM.ACCOUNT.contact = this.kiosk.ACCOUNT_CONTACT
					this.SEPTIM.ACTIVE = this.kiosk.SEPTIM_ACTIVE
					this.SEPTIM.AUTH = this.kiosk.SEPTIM_AUTH
					this.languages = this.kiosk.languages.split(",").map((row) => {
						return this.localeOptions.find(item => item.code === row)
					})

				})
				/*.then((res) => {
					if(this.SEPTIM.ACTIVE == 'true') {
						const config = {
							url: '1.0',
							webcare: this.kiosk.SEPTIM_WEBCARE,
							version: this.kiosk.SEPTIM_URL
						}
						axios.post(`${API_URL}/api/septim/v2/startSession`, config) // POST ma byt
							.then((response) => {
								// console.log("Vraciam TOKEN", response.data);
								this.SEPTIM.TOKEN = response.data.sessionToken
							})
							.catch((error) => {
								console.log("Error:getKioskAuth", error)
							})
					}
				})*/
				.then((res) => {
					if(this.SEPTIM.ACTIVE == 'true') {
						const config = {
							version: '1.0',
							webcare: this.kiosk.SEPTIM_WEBCARE,
							url: this.kiosk.SEPTIM_URL
						}
						axios.post(`${API_URL}/api/septim/v2/startSession`, config, {
							headers: {
								'Content-Type': 'application/json'
							}
						}) // POST ma byt
							.then((response) => {
								// console.log("Vraciam TOKEN", response.data);
								this.SEPTIM.TOKEN = response.data.sessionToken
							})
							.catch((error) => {
								console.log("Error:getKioskAuth", error)
							})
					}
				})
				.catch((error) => {
					// handle error
					console.log("Error:getKiosk", error);
				})
		},
		getCategories() {
			// var myHeaders = new Headers();

			// var requestOptions = {
			// 	method: "GET",
			// 	headers: myHeaders,
			// 	redirect: "follow",
			// };
			// Upravit API s UID
			if(this.uid == 0 || this.uid == '' || API_URL == '') {
				this.categories = []
			} else {
				axios.get(`${API_URL}/api/${this.uid}/categories`)
					.then((response) => {
						this.categories = response.data
					})
					.catch((error) => {
						console.log("Error:getCategories", error)
					})
			}

		},
		getProducts() {
			if(this.uid == 0 || this.uid == '') {
				this.products = []
			} else {
				axios.get(`${API_URL}/api/${this.uid}/products`)
					.then((response) => {
						this.products = response.data.map((row) => {
							row.tax = row.tax === null ? 0 : row.tax
							row.total =
								row.total === null
									? row.price
									: row.total
							return row
						})
					})
					.catch((error) => {
						console.log("Error:getProducts", error)
					})
			}
		},
		getMenu() {
			if(this.openMenu == 0 || this.uid == '') {
				return []
			}
			axios.get(`${API_URL}/api/${this.uid}/menu`)
				.then((response) => {
					this.menuList = response.data[0].menuList
					console.log("getMenu", this.menuList);
					this.updateMenuState(this.openMenu);
				})
				.catch((error) => {
					console.log("Error:getMenu", error)
				})
		},
		getParameters() {
			if(this.openMenu == 0 || this.uid == '') {
				return []
			}
			axios.get(`${API_URL}/api/${this.uid}/params`)
				.then((response) => {
					const res = response.data
					this.currency = res[0].currency.shortcode
					this.currencyObject = res[0].currency
					this.bid = res[0].id

					console.log('Response from params api:', res)
				})
				.catch((error) => {
					console.log("Error:getParameters", error)
				})
		},
		updateMenuState(id) {
			this.openMenu = id;
			if(id > 0) {
				const obj = this.menuList;
				for(const key in obj) {
					if(Object.hasOwnProperty.call(obj, key)) {
						const el = obj[key];
						if(el.id == id) {
							// console.log("Items", el);
							this.itemList = el.products;
						}
					}
				}
			} else {
				this.itemList = [];
			}
		},
		loadMenuDetails(item) {
			// console.log("Details", item);
			this.selectedItem = item.element;
		},
		toggleDrawer() {
			this.drawerOpen = !this.drawerOpen;
		},
		setDrawer(val) {
			// console.log("setDrawer", val);
			this.drawerOpen = val;
		},
		updateIngredients(val) {
			const arr = this.selectedItem.ingredients;
			const idx = arr.findIndex((i) => {
				return val.oldVal == i;
			});

			if(idx > -1) {
				arr.splice(idx, 1, val.newVal);
			}
			this.selectedItem.ingredients = arr;
		},
		// DEPRECATED:
		setDefaultKioskValues() {
			// console.log("Set default vals");
			// this.openMenu = LocalStorage.getItem('openMenu') // HACK:
			// Get from local DB!!! Async

			// Default menu
			this.openMenu = 1
			this.drawerOpen = true; // TODO: from settings
			this.selectedItem = {};
			this.processState = "intro";

			// this.getKiosk();
		},
		async checkSetup() {
			if(this.uid == '' || this.openMenu == 0) {
				// this.setUidDialog = true
				// console.log("Unset");
				// Open Setup
				return true
			} else {
				return false
				// this.setUidDialog = false
				// console.log("System SET");
			}
		},
		testPay() {
			var myHeaders = new Headers();

			var requestOptions = {
				method: "GET",
				headers: myHeaders,
				redirect: "follow",
			};
			// Upravit API s UID
			if(this.openMenu == 0 || this.uid == '') {
				return []
			}
			// const API_URL = API_URL
			fetch(`${API_URL}/api/${this.uid}/payment`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					console.log("Payment", JSON.parse(result));
					// const res = JSON.parse(result)

				})
				.catch((error) => console.log("Error:testPay", error));
		},
		callAlert(alrt = '') {

			/*Dialog.create({
				title: 'Alert',
				message: alrt.message
			}).onOk(() => {
				// console.log('OK')
			}).onCancel(() => {
				// console.log('Cancel')
			}).onDismiss(() => {
				// console.log('I am triggered on both OK and Cancel')
			})*/
		},
		// TODO:
		updateSetting(set) {

			// console.log("Update data in controller", set);
			// TODO: NOva URL
			axios.post(`${API_URL}/api/updateset`, {
				id: set.id,
				meta: set.meta,
				metaval: set.metaval
			})
				.then((response) => {
					// console.log(response);
					this.getKiosk()
				})
				.catch((error) => {
					console.log("Error:updateSetting", error);
					this.callAlert(error)
				});
		},
		// TODO:
		deleteSetting(id) {
			// console.log("Delete setting from controller!", id);
			axios.get(`${API_URL}/api/deleteset/${id}`) // TODO: NOva URL
				.then((response) => {
					// console.log("Done", response);
					this.getKiosk()
				})
				.catch((error) => {
					// handle error
					console.log("Error:deleteSetting", error);
					this.callAlert(error)
				})

		},
		// TODO:
		deleteAllSetting() {
			axios.get(`${API_URL}/api/deleteall`)
				.then((response) => {
					// console.log("Done", response);
					this.getKiosk()
				})
				.catch((error) => {
					// handle error
					console.log("Errro:deleteAllSetting", error);
					this.callAlert(error)
				})
		},
		// async getServerKiosk(uid, url) {
		// 	console.log("Get kiosk settings from Admin server.", uid, url);
		// 	await axios.get(`${url}/api/${uid}/kiosk`) // TODO: NOva URL
		// 		.then((response) => {
		// 			console.log("Server data", response.data);
		// 			this.syncedKiosk = response.data
		// 			if(response.data == undefined) {
		// 				this.callAlert({
		// 					message: "Kiosk UID is not valid!"
		// 				})
		// 				this.syncState = false
		// 			} else {
		// 				this.syncState = true
		// 			}
		// 		})
		// 		.catch((error) => {
		// 			// handle error
		// 			console.log(error);
		// 			this.syncState = false
		// 			this.callAlert(error)
		// 		})
		// },
		// TODO:
		syncSetting(url) {
			// 2. Check local DB and Insert/Update
			console.log("Syncing", this.syncedKiosk);
			let kid = this.syncedKiosk.kid;
			let vals = []
			for(const key in this.syncedKiosk) {
				if(Object.hasOwnProperty.call(this.syncedKiosk, key)) {
					const el = this.syncedKiosk[key];
					const set = {}
					// console.log(`Key: ${key} - Value: ${el}`);
					if(key == 'id') {
						kid = el
						continue;
					}
					if(key == 'status') {
						continue;
					}

					set['meta'] = key
					set['metaval'] = el

					vals.push(set)
				}
			}

			vals.map((row) => {
				row.kid = kid
				return row
			})

			let u = {
				kid: kid,
				meta: 'serverUrl',
				metaval: url
			}
			vals.push(u)

			// console.log(vals);

			axios.post(`${API_URL}/api/replaceset`, vals) // TODO: NOva URL
				.then((response) => {
					console.log("syncSetting", response);
					this.getKiosk()
				})
				.catch((error) => {
					console.log("Error:syncSetting", error);
					this.callAlert(error)
				});

		},
		async checkUID(uid) {
			return await axios.get(`${API_URL}/api/checkuid/${uid}`)
				.then((response) => {
					// console.log("Server data", response.data);
					return response.data

				})
				.catch((error) => {
					// handle error
					console.log("Error:checkUID", error);
					// this.callAlert(error)
				})

		}
	}
});
